<template>
  <div class="sezione "  style="padding:0 20px;">


<div class="yo-fixed-top" style="top:132px;z-index:999;">
<div class="row el-container" style="background:#fff;padding:16px 20px;">
   <div class="col s12">
      <el-breadcrumb separator-class="el-icon-arrow-right" style="">
         <el-breadcrumb-item>Centro</el-breadcrumb-item>
         <el-breadcrumb-item>Materiale</el-breadcrumb-item>
      </el-breadcrumb>
   </div>
</div>
</div>


<div class="title_h1 yo-color-primary" style="margin-top:30px;">MODULI FIRMATI</div>
<br />
<div class="row pad" style="margin-top:20px;">
  <div class="col s1 yo-align-right"><a  :href="'/upload/'+$centro.profile.row.id+'/'+JSON.parse($centro.profile.row.doc1)[0].url" style="" target="_blank"><i class="material-icons">cloud_download</i></a></div>
  <div class="col s11" style="line-height:26px;">Accordo di collaborazione scientifica tra SIN e il centro, titolare del trattamento dei dati </div>
</div>

<div class="row pad" style="margin-top:20px;margin-bottom:30px;">
  <div class="col s1 yo-align-right"><a  :href="'/upload/'+$centro.profile.row.id+'/'+JSON.parse($centro.profile.row.doc3)[0].url" style="" target="_blank"><i class="material-icons">cloud_download</i></a></div>
  <div class="col s11" style="line-height:26px;">Atto di nomina ad amministratore di sistema </div>
</div>
   


<br />
<div class="title_h1 yo-color-primary" style="margin-top:30px;">INFORMATIVA PAZIENTE</div>
Ogni Centro si impegna inoltre a fornire idonea informativa e richiesta consenso trattamento dati ai genitori dei pazienti utilizzando 
il modulo “INFORMATIVA PRIVACY AI SENSI DELL’ ART. 13 REGOLAMENTO EUROPEO N. 679/2016“ disponibile qui oppure utilizzando 
l’informativa del proprio Centro in cui venga inserita l’apposita finalità di “trattamento dei dati per la partecipazione e lo svolgimento del progetto INSINN" e ad ottenere il preventivo consenso ai sensi della vigente normativa in materia di privacy (D.lgs. 196/2003 come novellato dal D.lgs. 101/2018 e Regolamento Europeo 679/2016)”.


<div class="row pad" style="margin-top:20px;margin-bottom:30px;">
  <div class="col s1 yo-align-right"><a  href="/documenti/INFO_PAZIENTI.pdf" style="" target="_blank"><i class="material-icons">cloud_download</i></a></div>
  <div class="col s11" style="line-height:26px;">Informativa Pazienti</div>
</div>

  </div>
</template>

<script>
export default {

}
</script>


<style scoped>

</style>
